'use client'

import { useEffect, useMemo, useState } from 'react'

import { useIsConsentGroupEnabled, ConsentGroup } from '@marketplace-web/shared/consent'
import { AdShape } from '@marketplace-web/domain/ads-data'

function useShouldRenderAd(shape?: AdShape, isVanAd?: boolean): boolean {
  const isConsentGroupEnabled = useIsConsentGroupEnabled(ConsentGroup.Targeting)
  const isLeaderboard = useMemo(() => shape === AdShape.Leaderboard, [shape])

  const [shouldRender, setShouldRender] = useState<boolean>(isConsentGroupEnabled)

  useEffect(() => {
    if (isVanAd) {
      setShouldRender(true)

      return
    }

    if (isLeaderboard && isConsentGroupEnabled) return

    setShouldRender(isConsentGroupEnabled)
  }, [isConsentGroupEnabled, isLeaderboard, isVanAd])

  return shouldRender
}

export default useShouldRenderAd
